function searchFormSubmit(event = null) {
    if (event !== null) {
        event.preventDefault();
    }
    setTimeout(() => {
        document.querySelector('#searchForm').submit();
    }, 100);// 100ms Safari fix?
}

export { searchFormSubmit };
